import PropTypes from 'prop-types';

import { getPagePath, getResourcePath } from '@spotahome/soyuz/client';

import './InstitutionCard.scss';

const BACKGROUND_IMAGE = 'default_institutions.jpg';
const EMPTY_OBJECT = {};

const InstitutionCard = ({ institution = EMPTY_OBJECT }) => {
  const imageUrl = getResourcePath(
    `/images/institution/${institution.cardImage || BACKGROUND_IMAGE}`
  );
  const inlineStyles = {
    background: `url(${imageUrl}) top center`,
    backgroundSize: 'cover'
  };

  return (
    <div className="instituttion-card" style={inlineStyles}>
      <a
        href={getPagePath('institution', {
          params: { institution: institution.ID }
        })}
        className="instituttion-card__item"
      >
        <span className="instituttion-card__info-name">
          {institution.nameInstitution}
        </span>
      </a>
    </div>
  );
};

InstitutionCard.propTypes = {
  institution: PropTypes.object
};

export default InstitutionCard;
